// Used in stimulus-activity.component.ts

import { Injectable } from "@angular/core";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Injectable()
export class ProcessStimuliHelper {
    urlRemnants = "";
    linkOutput: string | SafeHtml = "";
    index?: number;
    stimuliProtocol = "";
    stimuliType = "";
    singleLinkChecked = false;

    constructor(private domSanitizer: DomSanitizer) {}

    public processStimuliLink_Module(
        stimuli: string,
        moduleID: number,
        isAdmin: boolean
    ) {
        this.singleLinkChecked = false;
        this.linkOutput = "";
        this.index = stimuli.indexOf("://");
        this.stimuliProtocol = stimuli.substring(0, this.index + 3);
        this.stimuliType = this.stimuliProtocol.replace("://", "");
        stimuli = stimuli.replace(this.stimuliProtocol, "");

        this.urlRemnants = stimuli.slice(0, stimuli.length);
        stimuli = JSON.parse(stimuli);
        // Checks if multi-dimentional array (multiple stimuli)
        if (
            Array.isArray(stimuli) &&
            stimuli.length > 1 &&
            stimuli.indexOf("[[") > -1
        ) {
            for (let i = 0; i < stimuli.length; i++) {
                switch (this.stimuliType) {
                    case "emcl":
                        stimuli[i][0] =
                            "../resources/moduledata/" + this.urlRemnants;
                        if (stimuli[i].length === 1) {
                            stimuli[i].push("Resource Document");
                        }
                        this.linkOutput +=
                            "" +
                            moduleID +
                            '<a target="_blank" href="/">' +
                            stimuli[i][0] +
                            "" +
                            stimuli[i][1] +
                            "</a><br/>";
                        break;

                    default:
                        this.index = stimuli[i][0].indexOf("://");
                        if (this.index && this.index > -1) {
                            this.stimuliProtocol = stimuli[i][0].substring(
                                0,
                                this.index + 3
                            );
                            stimuli[i][0] = stimuli[i][0].replace(
                                this.stimuliProtocol,
                                ""
                            );
                        }

                        if (this.stimuliProtocol === "emcl://") {
                            stimuli[i][0] = stimuli[i][0].replace(
                                this.stimuliProtocol,
                                ""
                            );
                            this.linkOutput +=
                                '<a target="_blank" href="../resources/moduledata/' +
                                moduleID +
                                "/" +
                                stimuli[i][0] +
                                '">' +
                                "Resource Document" +
                                "</a><br/>";
                        } else if (this.stimuliProtocol === "youtube://") {
                            this.linkOutput =
                                <string>this.linkOutput +
                                this.domSanitizer.bypassSecurityTrustHtml(
                                    '<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/' +
                                        stimuli[i][0] +
                                        '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="You Tube iframe"></iframe></div><br/>'
                                );
                        } else if (this.stimuliProtocol === "gmap://") {
                            this.linkOutput =
                                <string>this.linkOutput +
                                this.domSanitizer.bypassSecurityTrustHtml(
                                    '<iframe frameborder="0" src="https://www.google.com/maps/embed/v1/search?key=AIzaSyB7i0dGLYuQ6lgKZLNvu0llq5L61O9j0vI&q=' +
                                        stimuli[i][0] +
                                        '&zoom=12" title="Google Maps iframe"></iframe><br/><br/>'
                                );
                        } else if (stimuli[i].length <= 2) {
                            this.linkOutput +=
                                '<a target="_blank" href="http://' +
                                stimuli[i][0] +
                                '">' +
                                stimuli[i][1] +
                                "</a><br/>";
                        } else {
                            if (this.singleLinkChecked === false) {
                                this.linkOutput +=
                                    '<a target="_blank" href="' +
                                    stimuli[0] +
                                    '">' +
                                    stimuli[1] +
                                    "</a><br/>";
                                this.singleLinkChecked = true;
                            }
                        }
                        break;
                }
            }
            return this.domSanitizer.bypassSecurityTrustHtml(
                <string>this.linkOutput
            );
        } else {
            this.urlRemnants = this.urlRemnants
                .toString()
                .replace('["', "")
                .replace('"]', "");

            switch (this.stimuliType) {
                case "emcl":
                    stimuli =
                        "./resources/moduledata/" +
                        moduleID +
                        "/" +
                        this.urlRemnants;
                    this.linkOutput +=
                        '<a target="_blank" href="' +
                        stimuli +
                        '">' +
                        "Resource Document" +
                        "</a><br/>";
                    break;

                case "youtube":
                    stimuli =
                        '<iframe src="https://www.youtube.com/embed/' +
                        this.urlRemnants +
                        '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen title="You Tube iframe"></iframe>';
                    this.linkOutput += stimuli;
                    this.linkOutput = this.domSanitizer.bypassSecurityTrustHtml(
                        <string>this.linkOutput
                    );
                    break;
                case "vimeo":
                    stimuli =
                        "http://player.vimeo.com/video/" + this.urlRemnants;
                    this.linkOutput += stimuli;
                    this.linkOutput = this.domSanitizer.bypassSecurityTrustUrl(
                        <string>this.linkOutput
                    );
                    break;
                case "gmap":
                    stimuli =
                        '<iframe frameborder="0" src="https://www.google.com/maps/embed/v1/search?key=AIzaSyB7i0dGLYuQ6lgKZLNvu0llq5L61O9j0vI&q=' +
                        this.urlRemnants +
                        '&zoom=12" title="Google Maps iframe"></iframe><br/><br/>';
                    this.linkOutput += stimuli;
                    this.linkOutput = this.domSanitizer.bypassSecurityTrustHtml(
                        <string>this.linkOutput
                    );
                    break;
                case "avenue":
                    this.linkOutput = stimuli;
                    break;
                default:
                    if (stimuli.length > 1) {
                        this.linkOutput +=
                            '<a target="_blank" href="' +
                            stimuli[0] +
                            '">' +
                            stimuli[1] +
                            "</a>";
                    } else {
                        this.linkOutput +=
                            '<a target="_blank" href="' +
                            this.urlRemnants +
                            '">' +
                            this.urlRemnants +
                            "</a>";
                    }
                    break;
            }
            return this.linkOutput;
        }
    }

    public processStimuliLink_Lesson(stimuli = "", noProtocol: boolean) {
        // stimuli might be undefined, and this seems like a decent way to account for that while still typing it string?
        this.linkOutput = "";
        if (noProtocol) {
            this.urlRemnants = stimuli;
        } else {
            this.index = stimuli.indexOf("://");
            if (this.index) {
                this.stimuliProtocol = stimuli.substring(0, this.index + 3);
            }
            this.stimuliType = this.stimuliProtocol.replace("://", "");
            stimuli = stimuli.replace(this.stimuliProtocol, "");

            this.urlRemnants = stimuli.slice(0, stimuli.length);
            this.urlRemnants = this.urlRemnants
                .toString()
                .replace('["', "")
                .replace('"]', "");
        }

        // word, excel, powerpoint, txt, pages, pdf, jpg, png, bmp, gif, mp4, mov, flv

        if (
            this.urlRemnants.includes("youtube") ||
            this.urlRemnants.includes("youtu.be")
        ) {
            this.stimuliType = "youtube";
        } else if (this.urlRemnants.includes("vimeo")) {
            this.stimuliType = "vimeo";
        } else if (this.urlRemnants.includes("google.com/maps")) {
            this.stimuliType = "gmap";
        }

        function getYoutubeId(url: string) {
            const regExp =
                /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            const match = url.match(regExp);

            if (match && match[2].length === 11) {
                return match[2];
            } else {
                return "error";
            }
        }

        function getVimeoID(url: string) {
            const vimeoBase = "https://vimeo.com/";
            url = url.replace(vimeoBase, "");
            return url;
        }

        switch (this.stimuliType) {
            case "youtube":
                const youtubeId = getYoutubeId(this.urlRemnants);
                if (youtubeId === "error") {
                    this.linkOutput =
                        '<a target="_blank" href="' +
                        this.urlRemnants +
                        '">' +
                        this.urlRemnants +
                        "</a>";
                } else {
                    stimuli =
                        '<div class="videoWrapper" fxLayout="row wrap"><iframe src="https://www.youtube.com/embed/' +
                        youtubeId +
                        '" frameborder="0" allowfullscreen title="You Tube iframe"></iframe></div>';
                    this.linkOutput += stimuli;
                }
                break;

            case "vimeo":
                const vimeoId = getVimeoID(this.urlRemnants);
                if (vimeoId === "error") {
                    this.linkOutput =
                        '<a target="_blank" href="' +
                        this.urlRemnants +
                        '">' +
                        this.urlRemnants +
                        "</a>";
                } else {
                    stimuli =
                        '<div class="vimeo"><iframe width="800" height="480" src="https://player.vimeo.com/video/' +
                        vimeoId +
                        '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen title="Vimeo iframe"></iframe></div>';
                    this.linkOutput += stimuli;
                }
                break;

            case "gmap":
                stimuli =
                    '<div class="gmap"><iframe frameborder="0" src="' +
                    this.urlRemnants +
                    '&zoom=12" title="Google Map iframe"></iframe></div><br/><br/>';
                this.linkOutput += stimuli;
                break;

            default:
                if (!this.linkOutput) {
                    this.linkOutput = "";
                }
                this.linkOutput +=
                    '<a target="_blank" href="' +
                    this.urlRemnants +
                    '">' +
                    this.urlRemnants +
                    "</a>";
                break;
        }
        return this.domSanitizer.bypassSecurityTrustHtml(
            <string>this.linkOutput
        );
    }

    /**
     * Function was created to deserilize the stimuli so the html function processStimuliLink will only receive single
     * stimuli instead of array because the html sanitizer for arrayed links breaks the hyperlinks, idk when this
     * will ever be fixed but this fixes it
     * @param {string} rawStimuli
     * @returns {any[]}
     */
    public generateStimuliLinkArray(rawStimuli: string) {
        if (rawStimuli == null) {
            // Undefined? Nothing to process! Bail out.
            return [];
        }

        let modifiedStimuli = rawStimuli;
        const linkArray: string[] = [];
        const index = modifiedStimuli.indexOf("://");
        const stimuliProtocol = modifiedStimuli.substring(0, index + 3);
        modifiedStimuli = modifiedStimuli.replace(stimuliProtocol, "");
        modifiedStimuli = JSON.parse(modifiedStimuli);

        if (
            Array.isArray(modifiedStimuli) &&
            modifiedStimuli.length > 1 &&
            rawStimuli.indexOf("[[") > -1
        ) {
            for (const stimuli of modifiedStimuli) {
                const singleStimuli = stimuli[0];
                const protocolIndex = singleStimuli.indexOf("://");
                const protocol = singleStimuli.substring(0, protocolIndex + 3);
                const modifiedSingleStimuli = singleStimuli.replace(
                    protocol,
                    ""
                );
                if (protocol === "http://" || protocol === "https://") {
                    linkArray.push(
                        `${protocol}["${singleStimuli}", "${stimuli[1]}"]`
                    );
                } else {
                    linkArray.push(`${protocol}["${modifiedSingleStimuli}"]`);
                }
            }
        } else {
            if (Array.isArray(modifiedStimuli) && modifiedStimuli.length > 1) {
                // http or https with link name
                linkArray.push(
                    `${stimuliProtocol}["${modifiedStimuli[0]}", "${modifiedStimuli[1]}"]`
                );
            } else {
                if (
                    modifiedStimuli === "http://" ||
                    modifiedStimuli === "https://"
                ) {
                    // http or https with no link name
                    linkArray.push(
                        `${stimuliProtocol}["${stimuliProtocol}${modifiedStimuli}"]`
                    );
                } else {
                    linkArray.push(`${stimuliProtocol}["${modifiedStimuli}"]`);
                }
            }
        }

        return linkArray;
    }
}
